import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Icon } from "@iconify/react";
import BotVerification from "../../BotVerification";

const Ctapage = ({ data }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    companyName: "",
    contactNumber: "",
    selectLocation: "",
    selectNoOfProducts: "",
    comments: "",
    source: "Website",
    subSource: "",
    utmsource: "",
    utm_campaign: "",
    utm_device: "",
    utmmedium: "",
    utm_term: "",
    utm_network: "",
    utm_content: "",
  });

  const [loading, setLoading] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);

  useEffect(() => {
    // On load: capture URL and UTM params
    const url = window.location.href;
    const params = new URLSearchParams(window.location.search);
    // console.log("URL Include:-", url)

    const updatedData = {
      subSource: url,
      utmsource: params.get("utm_source") || "Organic",
      utm_campaign: params.get("utm_campaign") || "Organic",
      utm_device: params.get("utm_device") || "Organic",
      utmmedium: params.get("utm_medium") || "Organic",
      utm_term: params.get("utm_term") || "Organic",
      utm_network: params.get("utm_network") || "Organic",
      utm_content: params.get("utm_content") || "Organic",
    };

    setFormData((prev) => ({ ...prev, ...updatedData }));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!turnstileToken) {
        alert("Please complete the verification.");
        return;
      }

    const googleScriptUrl =
      "https://script.google.com/macros/s/AKfycbz8wlhLNBQgjQJtt0iqubkyIBIoxM-eOVGeMtmPj3CQY5IlzA5LgUuCcHtjprhT1VaH/exec";

    const payload = {
        // access_code: "8F18-F3A4-EE3D-7FF4-1FA2-6F9F",
      access_code:"1BEA-BAFF-A9D4-54DC-860C-4B5F",
      name: formData.name,
      email: formData.email,
      phone: formData.contactNumber,
      // source: "Website",
      source: formData.source,
      // additional_col1_select: formData.selectLocation,
      location:formData.selectLocation,
      company_name: formData.companyName,
      enquiry: formData.comments,
      no_of_products: formData.selectNoOfProducts,
      sub_source: formData.subSource,
      utm_source: formData.utmsource,
      utm_campaign: formData.utm_campaign,
      utm_device: formData.utm_device,
      utm_medium: formData.utmmedium,
      utm_term: formData.utm_term,
      utm_network: formData.utm_network,
      utm_content: formData.utm_content,
    };

    const formDataToSubmit = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSubmit.append(key, value);
    });

    const urlEncodedFormData = new URLSearchParams();
Object.entries(formData).forEach(([key, value]) => {
  urlEncodedFormData.append(key, value);
});
    

    try {
        const [leadApiResText] = await Promise.all([
          // Lead API
          // fetch("https://growtheye.com/leadApiBeta.php", {
          // fetch("https://leadapi.scaledino.com/api/leads/web", {
          fetch("https://leadapi.growtheye.com/api/leads/web", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }).then((res) => res.text()),
      
          // Google Script (no-cors mode)
         await fetch(googleScriptUrl, {
            method: "POST",
            mode :"no-cors",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: urlEncodedFormData.toString(),
          })
        ]);
      
        if (leadApiResText.trim() !== "SUCCESSRound Robin Code Started") {
          console.error("Lead API Error:", leadApiResText);
        }
      
        // No googleRes.ok check here — response is opaque
      
        // window.location.href = "/thank-you";
        const currentPath = window.location.pathname;
        // console.log("Current path name", currentPath)
          if (currentPath === '/catalog/diwali') {
              // window.location.href = "https://drive.google.com/file/d/12_0z9KHsz3PgcikePsZ7kYP4U6Y5MnEf/view";
              window.location.href= 'https://diwali.eyantra.com/#/catalog'
            } 
              else if (currentPath === '/catalog/new-year') {
              window.location.href = "https://drive.google.com/file/d/1GzIckDhKWALkVPvgWK-a8ZWeo7VRue11/view";      
            }
              else if (currentPath === '/catalog/other-brand-catalog') {
              window.location.href = "https://drive.google.com/file/d/1533xv7cwLcHg7uNdejxkXEJhigOUITRL/view";
            } 
            else if (currentPath==='/gifting-report-2024'){
              window.location.href= "https://drive.google.com/file/d/1D7kA3qoDk9j-utDLS7LicpioorVhrbxj/view"
            }
            else {
              window.location.href = `/thank-you?email=${encodeURIComponent(formData.email)}&name=${encodeURIComponent(formData.name)}`;
            }
        
      } catch (error) {
        console.error("Submission error:", error);
        alert("There was an error with the form submission.");
      } finally {
        setTurnstileToken(null);
        setLoading(false);
      }
      
    } 

  return (
    <Container className="bgeYantraCTA p-md-5 p-3 my-5">
      <Row className="align-items-center" id="contact-form">
        <Col md={5}>
          <h1 className="text-white" id="headingFontSize">
            {data[0].pageName}
          </h1>
          <p className="text-white fs-16" style={{ fontStyle: "italic" }}>
            {data[0].paragraphitalic}
          </p>
          <p className="fst-normal text-white fs-6">{data[0].paragraphText}</p>
        </Col>

        <Col md={7}>
          <div className="bg-white p-3" style={{ borderRadius: "30px" }}>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6} className="py-1">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-control bgFormInput px-3 py-2 m-1"
                    placeholder="Your Name"
                    required
                  />
                </Col>
                <Col md={6} className="py-1">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-control bgFormInput px-3 py-2 m-1"
                    placeholder="Your Email Address"
                    required
                  />
                </Col>
                <Col md={6} className="py-1">
                  <input
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    className="form-control bgFormInput px-3 py-2 m-1"
                    placeholder="Your Company Name"
                    required
                  />
                </Col>
                <Col md={6} className="py-1">
                  <input
                    type="text"
                    pattern="[6-9]{1}[0-9]{9}"
                    name="contactNumber"
                    title="Enter a valid contact number"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    className="form-control bgFormInput px-3 py-2 m-1"
                    placeholder="Your Contact Number"
                    maxlength="10"
                    required
                  />
                </Col>
                <Col md={6} className="py-1">
                  <select
                    name="selectLocation"
                    value={formData.selectLocation}
                    onChange={handleChange}
                    className="form-control bgFormInput px-3 py-2 mx-1"
                    required
                  >
                    <option value="" hidden>
                      Select Location
                    </option>
                    <option value="Hyderabad">Hyderabad</option>
                    <option value="Bangalore">Bangalore</option>
                    <option value="Gurugram">Gurugram</option>
                    <option value="Delhi">Delhi</option>
                    <option value="Noida">Noida</option>
                    <option value="Other">Other</option>
                  </select>
                </Col>
                <Col md={6} className="py-1">
                  <select
                    name="selectNoOfProducts"
                    value={formData.selectNoOfProducts}
                    onChange={handleChange}
                    className="form-control bgFormInput px-3 py-2 mx-1"
                    required
                  >
                    <option value="" hidden>
                      No. Of Products
                    </option>
                    <option value="50-100 products">50-100 Products</option>
                    <option value="100-200 products">100-200 Products</option>
                    <option value="200-300 products">200-300 Products</option>
                    <option value="above500 products">Above 500 Products</option>
                  </select>
                </Col>
                <Col md={12} className="py-1">
                  <textarea
                    name="comments"
                    value={formData.comments}
                    onChange={handleChange}
                    className="form-control bgFormInput px-3 py-2 m-1"
                    placeholder="Enquiry"
                    required
                  />
                </Col>
                 <BotVerification onVerify={setTurnstileToken} />
                <Col className="text-center mt-3">
                  <Button
                    type="submit"
                    className="m-auto rounded-pill py-2 px-4 border-0 fs-16"
                    id="btnSubmit"
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}{" "}
                    <Icon
                      icon="tabler:circle-arrow-up-right-filled"
                      width="24"
                      height="24"
                      style={{ color: "#fff" }}
                    />
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Ctapage;
